module.exports = __webpack_public_path__ + "static/img/logo_header.d948dd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_header.png
// module id = oiqA
// module chunks = 31